import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SafeHtmlService } from '../services/safe-html.service';

@Pipe({ name: 'getPreview' })
export class GetPreviewPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer, private safeHtmlService: SafeHtmlService) {}
  transform(content: string): SafeHtml {
    if (!content) return '';
    let sanitized = this.safeHtmlService.getSafeHtmlWithStyles(content);
    let result = this.getFirstChild(sanitized);
    return this.sanitizer.bypassSecurityTrustHtml(result);
  }

  private replaceEmptyParagraphs(text: string) {
    return text
      .replace(new RegExp(`<ol><li>&nbsp;</li></ol>`, 'g'), '')
      .replace(new RegExp(`<ul><li>&nbsp;</li></ul>`, 'g'), '')
      .replace(new RegExp(`<blockquote><p>&nbsp;</p></blockquote>`, 'g'), '')
      .replace(new RegExp(`<p>&nbsp;</p>`, 'g'), '')
      .replace(new RegExp(`<p>&#160;</p>`, 'g'), '')
      .replace(new RegExp(`<h1>&nbsp;</h1>`, 'g'), '')
      .replace(new RegExp(`<h1>&#160;</h1>`, 'g'), '')
      .replace(new RegExp(`<h2>&nbsp;</h2>`, 'g'), '')
      .replace(new RegExp(`<h2>&#160;</h2>`, 'g'), '')
      .replace(new RegExp(`<h3>&nbsp;</h3>`, 'g'), '')
      .replace(new RegExp(`<h3>&#160;</h3>`, 'g'), '')
      .replace(new RegExp(`<p></p>`, 'g'), '')
      .replace(new RegExp(`<h1></h1>`, 'g'), '')
      .replace(new RegExp(`<h2></h2>`, 'g'), '')
      .replace(new RegExp(`<h3></h23>`, 'g'), '')
      .replace(new RegExp(`&nbsp;`, 'g'), '');
  }

  private getFirstChild(htmlString: string) {
    let div = document.createElement('div');
    div.innerHTML = this.replaceEmptyParagraphs(htmlString.trim());
    let p = div.querySelector('p:not(:empty)');
    return p ? p.innerHTML : div.innerHTML;
  }
}
